const termsAndConditionsContent = `
  <h1>Terms & Conditions</h1>
  <p>These Terms & Conditions ("Terms") govern your access to and use of the ReadRivals application (the "App"). By accessing or using the App you agree to be bound by these Terms. If you do not agree, do not use the App.</p>

  <h2>1. Subscription & Billing</h2>
  <p>Subscriptions automatically renew unless cancelled at least 24 hours prior to the end of the current billing cycle. By purchasing a subscription you authorize us (and the applicable app store) to charge the recurring subscription fee to your chosen payment method until you cancel. You may manage and cancel your subscription through your platform account settings.</p>

  <h2>2. License & Acceptable Use</h2>
  <p>We grant you a limited, non-exclusive, non-transferable, revocable license to use the App for personal, non-commercial purposes. You agree not to reverse engineer, redistribute, exploit, or use the App in any unlawful manner.</p>

  <h2>3. Content & Intellectual Property</h2>
  <p>All content, features, and functionality (including text, graphics, logos, and software) are owned by ReadRivals or its licensors and are protected by intellectual property laws. Any unauthorized use may violate these laws.</p>

  <h2>4. User Generated Interactions</h2>
  <p>If the App allows you to submit feedback or suggestions, you grant us a worldwide, royalty-free, perpetual license to use and incorporate that feedback without compensation.</p>

  <h2>5. Service Changes</h2>
  <p>We may modify, suspend, or discontinue any part of the App at any time with or without notice. We are not liable for any such changes.</p>

  <h2>6. Refunds</h2>
  <p>Except where required by law, payments are non-refundable and there are no refunds or credits for partially used periods.</p>

  <h2>7. Disclaimer of Warranties</h2>
  <p>The App is provided on an "AS IS" and "AS AVAILABLE" basis without warranties of any kind, express or implied, including but not limited to merchantability, fitness for a particular purpose, or non-infringement.</p>

  <h2>8. Limitation of Liability</h2>
  <p>To the maximum extent permitted by law, ReadRivals shall not be liable for indirect, incidental, special, consequential, or punitive damages, or loss of data, profits, or use arising out of your use of the App.</p>

  <h2>9. Termination</h2>
  <p>We may suspend or terminate your access if we reasonably believe you have violated these Terms. Upon termination, the rights granted to you will cease immediately.</p>

  <h2>10. Changes to Terms</h2>
  <p>We may update these Terms from time to time. Continued use after changes constitutes acceptance of the revised Terms.</p>

  <h2>11. Contact</h2>
  <p>For questions about these Terms you can contact us at: <a href="mailto:generalquestions@readwellllc.com">generalquestions@readwellllc.com</a></p>

  <h2>12. Copyright Infringement Prohibition</h2>
  <p>Users are strictly prohibited from uploading, posting, or submitting any content that infringes upon the intellectual property rights of others.</p>

  <h2>13. Repeat Infringer Policy</h2>
  <p>Accounts found to repeatedly upload infringing material (defined as receiving two or more valid DMCA notices) will be permanently terminated without notice.</p>

  <h2>14. Indemnification</h2>
  <p>By uploading content, you agree to indemnify, defend, and hold harmless ReadRivals LLC from any claims, damages, liabilities, costs, and legal fees resulting from your violation of third-party copyrights.</p>

  <h2>15. AI Features and Third-Party Services</h2>
  <p>ReadRivals provides an AI-powered reading companion called Buddy, which uses artificial intelligence technology provided by OpenAI.</p>
  <p>When users interact with Buddy, certain information, including voice input, conversation transcripts, and relevant reading content, may be transmitted to OpenAI to process requests and generate responses.</p>
  <p>These services are provided to support interactive reading assistance, conversational learning, and personalized reading experiences.</p>
  <p>By using Buddy, users acknowledge that the feature relies on third-party AI technology.</p>
  <p>For additional information about how user information is collected, processed, and protected, please refer to our Privacy Policy.</p>

  <p style="margin-top:2rem;font-size:0.85rem;color:#666;">Last updated: ${(new Date()).getFullYear()}</p>
`;

export default termsAndConditionsContent;
